const isLoopbackHost = (hostname) => {
  if (!hostname) {
    return false;
  }

  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "::1" ||
    hostname.endsWith(".localhost")
  );
}

export const isLocalHostRuntime =
  typeof window !== "undefined" && isLoopbackHost(window.location.hostname);

export const isLocalAuthDisabled =
  isLocalHostRuntime && process.env.REACT_APP_PAY_PORTAL_LOCAL_DISABLE_AUTH === "true";

export const isLocalLoggedIn =
  isLocalAuthDisabled && process.env.REACT_APP_PAY_PORTAL_LOCAL_LOGGED_IN === "true";

export const localStripeCustomerId = isLocalHostRuntime
  ? process.env.REACT_APP_PAY_PORTAL_LOCAL_STRIPE_CUSTOMER_ID
  : undefined;

export const localBeehiveOnlineContactId = isLocalHostRuntime
  ? process.env.REACT_APP_PAY_PORTAL_LOCAL_BEEHIVE_ONLINE_CONTACT_ID
  : undefined;

export const localB2CUserId = isLocalHostRuntime
  ? process.env.REACT_APP_PAY_PORTAL_LOCAL_B2C_USER_ID
  : undefined;

export const localDatabaseName = isLocalHostRuntime
  ? process.env.REACT_APP_PAY_PORTAL_DATABASE_NAME
  : undefined;

export const isLocalStripeFrontendMockEnabled =
  isLocalHostRuntime &&
  process.env.REACT_APP_PAY_PORTAL_STRIPE_PROVIDER === "mock";
